<template>
  <div class="relative flex-container d-flex flex-column ai-center vision-bg">
    <div
      class="section-wrapper d-flex flex-column"
      v-bind:class="{ 'mg-150': !isMobile, 'mg-100': isMobile }"
    >
      <div class="header-2">Vision</div>

      <div class="relative flex-container">
        <div class="vision-thumb-wrap">
          <v-carousel
            v-model="current"
            hide-delimiters
            :show-arrows="false"
            height="100%"
          >
            <v-carousel-item v-for="(src, i) in imgSrc" :key="`img${i}`">
              <img class="vision-thumb" :src="src" />
            </v-carousel-item>
          </v-carousel>
        </div>
        <v-carousel
          v-model="current"
          hide-delimiters
          :show-arrows="false"
          height="fit-content"
        >
          <v-carousel-item v-for="(item, i) in items" :key="i">
            <div class="flex-container relative">
              <div class="flex-container flex-3 d-flex flex-column">
                <p
                  class="header-2 short-line underline"
                  v-bind:class="{ 'mg-150': !isMobile, 'mg-50': isMobile }"
                >
                  {{ item.title }}
                </p>

                <p class="text-2 vision-body mg-25">
                  {{ item.first }}
                  <br />
                  {{ item.second }}
                  <br />
                  {{ item.third }}
                </p>
              </div>
              <div
                v-if="current < items.length - 1"
                class="flex-container d-flex flex-column flex-2"
              >
                <p
                  class="header-2 short-line color-grey underline-grey"
                  v-bind:class="{ 'mg-150': !isMobile, 'mg-50': isMobile }"
                >
                  {{ items[current + 1].title }}
                </p>
              </div>
            </div>
          </v-carousel-item>
        </v-carousel>
      </div>

      <div class="mg-50 delimeters">
        <div class="text-1">{{ `0${current + 1}` }}</div>
        <div class="text-1 color-grey ma-1">/</div>
        <div class="text-1 color-grey">{{ `0${items.length}` }}</div>
        <v-progress-linear
          class="progress-bar"
          :value="sliderValue"
          color="#1c1c1c"
          height="2px"
        ></v-progress-linear>
        <template>
          <div v-if="current > 0" class="btn-prev" @click="prev" />
          <div v-else class="btn-prev disabled" />
        </template>
        <template>
          <div
            v-if="current < items.length - 1"
            class="btn-next"
            @click="next"
          />
          <div v-else class="btn-next disabled" />
        </template>
      </div>
      <div v-if="!isMobile" class="mg-150" />
      <div v-if="isMobile" class="mg-50" />
    </div>
  </div>
</template>

<script>
import src1 from "../assets/about_cart01.jpg";
import src2 from "../assets/about_cart02.jpg";
import src3 from "../assets/about_cart03.jpg";

export default {
  computed: {
    sliderValue() {
      return ((this.current + 1) * 100) / this.items.length;
    },
    thumb() {
      return this.imgSrc[this.current];
    },
    isMobile() {
      return window.innerWidth < 1000;
    },
  },
  data: () => ({
    current: 0,
    items: [
      {
        title: "Human",
        first: "데이터몬스터즈의 비전은 사람에 있습니다.",
        second: "우수한 기술도 인간의 노력에 의해 탄생하며",
        third: "궁극적으로 우리의 삶에 유익하여야 합니다.",
      },
      {
        title: "Technology",
        first: "기술은 생각을 현실로 옮기는 근간입니다.",
        second: "데이터몬스터즈는 끊임없는 탐색과 연구를 통해",
        third: "많은 사람이 꿈꿔온 미래를 실현하고 있습니다.",
      },
      {
        title: "Consilience",
        first: "학문 간의 경계가 모호해지는 융합의 시대,",
        second: "데이터몬스터즈는 뛰어난 기술력을 토대로",
        third: "영역을 뛰어넘은 지식의 통섭을 추구합니다.",
      },
    ],
    imgSrc: [src1, src2, src3],
  }),
  methods: {
    next() {
      this.current += 1;
    },
    prev() {
      this.current -= 1;
    },
  },
};
</script>

<style scoped>
.vision-bg {
  background: url("../assets/about_vision_bk.jpg") no-repeat center center;
  background-size: cover;
  overflow: hidden;
}
.vision-thumb-wrap {
  position: absolute;
  top: -340px;
  right: 0;
  width: 280px;
  height: 720px;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  transform: skew(-20deg, 0deg);
  z-index: 2;
}

.vision-thumb {
  width: 200%;
  margin-left: -50%;
  height: 100%;
  background-position: center;
  background-size: cover;
  transform: skew(20deg, 0deg) scale(2);
}

.underline {
  width: fit-content;
  border-bottom: 2px solid black;
}

.underline-grey {
  width: fit-content;
  border-bottom: 2px solid grey;
}

.delimeters {
  width: 100%;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  align-items: center;
}

.progress-bar {
  margin-left: 40px;
  width: 100px;
}

.short-line {
  line-height: 1;
}

.btn-prev {
  width: 16px;
  height: 16px;
  transition: 0.3s ease-in-out;
  background: url("../assets/prevbtn_on.png");
  margin-left: 25px;
  cursor: pointer;
}

.disabled {
  cursor: initial;
  opacity: 0.3;
  transition: 0.3s ease-in-out;
}

.btn-next {
  width: 16px;
  height: 16px;
  transition: 0.3s ease-in-out;
  background: url("../assets/nextbtn_on.png");
  margin-left: 25px;
  cursor: pointer;
}

@media only screen and (max-width: 880px) {
  .vision-thumb-wrap {
    position: absolute;
    top: -25px;
    right: -30px;
    width: 100px;
    height: 260px;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    transform: skew(-20deg, 0deg);
    z-index: 2;
  }

  .vision-body {
    min-height: 75px;
  }
}
</style>
